import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { MonetaryFields } from '@doordash/lib-i18n'
import { dxApiUrl } from '.'

export type GetFirstDashCampaignsSuccessPayload = {
  campaignId: string
  type: string
  payAmount: MonetaryFields | undefined
  startingPointId: number
  startingPointName: string
  activationTime: string
  activeUntilTime: string
}

/**
 * Retrieve a list of Dasher promotions based on their unique link
 * @param {string} uniqueLink - the Dasher Applicant unique link
 * @returns A promise resolving to GetFirstDashCampaignsSuccessPayload
 */
export const getFirstDashCampaignsById = async (
  uniqueLink: string
): Promise<AxiosResponse<GetFirstDashCampaignsSuccessPayload[]>> => {
  const opts: AxiosRequestConfig = { baseURL: dxApiUrl() }
  const url = `/v3/dasher_applicants/${uniqueLink}/first_dash_campaigns`
  return await axios.get(url, opts)
}
